import { useAtom } from "jotai";

import { ModelMetadataAtom, useGlobalMMMStore } from "../mmm-provider";

export const useModelMetadata = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [modelMetadata, setModelMetadata] = useAtom(ModelMetadataAtom, {
    store: GlobalMMMStore,
  });

  return [modelMetadata, setModelMetadata] as const;
};
